import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';
import { LoadCompany } from 'src/app/store/actions/company.actions';
import {
    LoadCentralRegulatorLogo,
    LoadCentralRegulatorLogoExtra,
    LoadCompanyLogo,
    LoadCompanyLogoExtra
} from 'src/app/store/actions/document.action';
import { companyById } from 'src/app/store/reducer/company.reducer';
import {
    centralRegulatorLogoById,
    centralRegulatorLogoExtraById,
    companyLogoById,
    companyLogoExtraById,
    DocumentUrlWithKey
} from 'src/app/store/reducer/document.reducer';
import { CompanyLogoDialogComponent } from '../../../administration/business-partners/details/company-logo-dialog/company-logo-dialog.component';
import { MatDialog } from '@iota/iota-ui-components';
import { CompanyMode } from '../../constants-and-enums/company-mode.enum';
import { centralRegulatorById } from '../../../store/reducer/central-regulators.reducer';

@Component({
    standalone: false,
    selector: 'app-company-avatar',
    templateUrl: './company-avatar.component.html'
})
export class CompanyAvatarComponent implements OnInit {
    logo$: Observable<DocumentUrlWithKey>;
    logoExtra$: Observable<DocumentUrlWithKey>;

    initials$: Observable<string>;

    @Input() businessPartnerId: string;
    @Input() avatarClasses = 'w-11 flex';
    @Input() enableEditLogo = false;
    @Input() mode: CompanyMode;

    constructor(
        private store: Store,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        if (this.mode === CompanyMode.REGULATOR) {
            this.initials$ = this.store.select(centralRegulatorById(this.businessPartnerId)).pipe(
                map((regulator) =>
                    regulator?.name
                        .split(' ')
                        .map((split) => split[0])
                        .join('')
                )
            );
            setTimeout(() => {
                this.store
                    .select(centralRegulatorLogoById(this.businessPartnerId))
                    .pipe(take(1))
                    .subscribe((logo) => {
                        if (!logo) {
                            this.store.dispatch(LoadCentralRegulatorLogo({ centralRegulatorId: this.businessPartnerId }));
                        }
                    });
            }, 0);

            setTimeout(() => {
                this.store
                    .select(centralRegulatorLogoExtraById(this.businessPartnerId))
                    .pipe(take(1))
                    .subscribe((logo) => {
                        if (!logo) {
                            this.store.dispatch(LoadCentralRegulatorLogoExtra({ centralRegulatorId: this.businessPartnerId }));
                        }
                    });
            }, 0);
            this.logo$ = this.store.select(centralRegulatorLogoById(this.businessPartnerId));
            this.logoExtra$ = this.store.select(centralRegulatorLogoExtraById(this.businessPartnerId));
        } else {
            if (this.businessPartnerId) {
                this.store
                    .select(companyById(this.businessPartnerId))
                    .pipe(take(1))
                    .subscribe((company) => {
                        if (!company) {
                            this.store.dispatch(LoadCompany({ companyId: this.businessPartnerId }));
                        }
                    });

                this.initials$ = this.store.select(companyById(this.businessPartnerId)).pipe(
                    map((company) =>
                        company?.name
                            .split(' ')
                            .map((split) => split[0])
                            .join('')
                    )
                );
            }
            setTimeout(() => {
                this.store
                    .select(companyLogoById(this.businessPartnerId))
                    .pipe(take(1))
                    .subscribe((logo) => {
                        if (!logo) {
                            this.store.dispatch(LoadCompanyLogo({ companyId: this.businessPartnerId }));
                        }
                    });
            }, 0);

            setTimeout(() => {
                this.store
                    .select(companyLogoExtraById(this.businessPartnerId))
                    .pipe(take(1))
                    .subscribe((logo) => {
                        if (!logo) {
                            this.store.dispatch(LoadCompanyLogoExtra({ companyId: this.businessPartnerId }));
                        }
                    });
            }, 0);
            this.logo$ = this.store.select(companyLogoById(this.businessPartnerId));
            this.logoExtra$ = this.store.select(companyLogoExtraById(this.businessPartnerId));
        }
    }
    openCompanyLogoDialog(isLogoExtra: boolean) {
        this.dialog.open(CompanyLogoDialogComponent, {
            data: {
                isLogoExtra,
                logo$: isLogoExtra ? this.logoExtra$ : this.logo$,
                businessPartnerId: this.businessPartnerId,
                mode: this.mode
            },
            width: '400px'
        });
    }
}
